window.magicDSL = [{
  id: "75f0extui9d7yksklx27hff8xg",
  name: "test",
  type: "app",
  codeBlocks: {},
  items: [
    {
      type: "page",
      id: "191",
      name: "index",
      title: "新威研选论文投稿激励活动",
      layout: "relative",
      style: {
        position: "relative",
        left: 0,
        top: 0,
        right: "",
        bottom: "",
        width: "100%",
        height: "auto",
        backgroundImage: "",
        backgroundColor: "rgba(255, 255, 255, 1)",
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%",
        color: "",
        fontSize: "",
        fontWeight: ""
      },
      events: [
        {
          name: "magic:common:events:click",
          actions: []
        },
        {
          name: "magic:common:events:click",
          actions: []
        }
      ],
      created: {
        hookType: "code",
        hookData: []
      },
      items: [
        {
          id: "container_cf41b676",
          type: "container",
          layout: "relative",
          style: {
            width: "100%",
            height: "auto",
            position: "relative",
            top: 0,
            left: 0,
            right: "",
            bottom: "",
            backgroundImage: "",
            backgroundColor: "rgba(255, 255, 255, 1)",
            backgroundRepeat: "no-repeat",
            backgroundSize: "100% 100%",
            color: "",
            fontSize: "",
            fontWeight: ""
          },
          name: "容器",
          items: [
            {
              id: "img_1f7e04b3",
              type: "img",
              style: {
                position: "relative",
                left: 0,
                width: "100%",
                height: "auto",
                top: 0,
                right: "",
                bottom: "",
                backgroundImage: "",
                backgroundColor: "",
                backgroundRepeat: "no-repeat",
                backgroundSize: "100% 100%",
                color: "",
                fontSize: "",
                fontWeight: ""
              },
              name: "图片",
              src: "https://file.neware.com.cn/ImageMaterialCenter/20240829164133638.jpg",
              url: "",
              events: "",
              created: "",
              mounted: "",
              displayConds: []
            }
          ],
          events: "",
          created: "",
          mounted: "",
          displayConds: []
        },
        {
          id: "container_2a6e540e",
          type: "container",
          layout: "relative",
          style: {
            width: "100%",
            height: "auto",
            position: "relative",
            top: 0,
            left: 0,
            right: "",
            bottom: "",
            backgroundImage: "",
            backgroundColor: "rgba(255, 255, 255, 1)",
            backgroundRepeat: "no-repeat",
            backgroundSize: "100% 100%",
            color: "",
            fontSize: "",
            fontWeight: ""
          },
          name: "容器",
          items: [
            {
              id: "img_e27ecb26",
              type: "img",
              style: {
                position: "relative",
                left: 0,
                width: "100%",
                height: "auto",
                top: 0,
                right: "",
                bottom: "",
                backgroundImage: "",
                backgroundColor: "",
                backgroundRepeat: "no-repeat",
                backgroundSize: "100% 100%",
                color: "",
                fontSize: "",
                fontWeight: ""
              },
              name: "图片",
              src: "https://file.neware.com.cn/ImageMaterialCenter/20240829164150899.jpg",
              url: "",
              events: "",
              created: "",
              mounted: "",
              displayConds: []
            }
          ],
          events: "",
          created: "",
          mounted: "",
          displayConds: []
        },
        {
          id: "container_f2382df5",
          type: "container",
          layout: "relative",
          style: {
            width: "100%",
            height: "auto",
            position: "relative",
            top: 0,
            left: 0,
            right: "",
            bottom: "",
            backgroundImage: "",
            backgroundColor: "rgba(255, 255, 255, 1)",
            backgroundRepeat: "no-repeat",
            backgroundSize: "100% 100%",
            color: "",
            fontSize: "",
            fontWeight: ""
          },
          name: "容器",
          items: [
            {
              id: "img_65d52809",
              type: "img",
              style: {
                position: "relative",
                left: 0,
                width: "100%",
                height: "auto",
                top: 0,
                right: "",
                bottom: "",
                backgroundImage: "",
                backgroundColor: "",
                backgroundRepeat: "no-repeat",
                backgroundSize: "100% 100%",
                color: "",
                fontSize: "",
                fontWeight: ""
              },
              name: "图片",
              src: "https://file.neware.com.cn/ImageMaterialCenter/20240830162113144.jpg",
              url: "",
              events: "",
              created: "",
              mounted: "",
              displayConds: []
            }
          ],
          events: "",
          created: "",
          mounted: "",
          displayConds: []
        },
        {
          id: "container_0dd90306",
          type: "container",
          layout: "relative",
          style: {
            width: "100%",
            height: "auto",
            position: "relative",
            top: 0,
            left: 0,
            right: "",
            bottom: "",
            backgroundImage: "",
            backgroundColor: "rgba(255, 255, 255, 1)",
            backgroundRepeat: "no-repeat",
            backgroundSize: "100% 100%",
            color: "",
            fontSize: "",
            fontWeight: ""
          },
          name: "容器",
          items: [
            {
              id: "img_480ca388",
              type: "img",
              style: {
                position: "relative",
                left: 0,
                width: "100%",
                height: "auto",
                top: 0,
                right: "",
                bottom: "",
                backgroundImage: "",
                backgroundColor: "",
                backgroundRepeat: "no-repeat",
                backgroundSize: "100% 100%",
                color: "",
                fontSize: "",
                fontWeight: ""
              },
              name: "图片",
              src: "https://file.neware.com.cn/ImageMaterialCenter/20240829164212918.jpg",
              url: "",
              events: "",
              created: "",
              mounted: "",
              displayConds: []
            }
          ],
          events: "",
          created: "",
          mounted: "",
          displayConds: []
        },
        {
          id: "container_2144536a",
          type: "container",
          layout: "relative",
          style: {
            width: "100%",
            height: "auto",
            position: "relative",
            top: 0,
            left: 0,
            right: "",
            bottom: "",
            backgroundImage: "",
            backgroundColor: "rgba(255, 255, 255, 1)",
            backgroundRepeat: "no-repeat",
            backgroundSize: "100% 100%",
            color: "",
            fontSize: "",
            fontWeight: ""
          },
          name: "容器",
          items: [
            {
              id: "img_d36c0fd8",
              type: "img",
              style: {
                position: "relative",
                left: 0,
                width: "100%",
                height: "auto",
                top: 0,
                right: "",
                bottom: "",
                backgroundImage: "",
                backgroundColor: "",
                backgroundRepeat: "no-repeat",
                backgroundSize: "100% 100%",
                color: "",
                fontSize: "",
                fontWeight: ""
              },
              name: "图片",
              src: "https://file.neware.com.cn/ImageMaterialCenter/3bc36a1e1d6c4612452fd5b9c6aca55e.jpg",
              url: "",
              events: "",
              created: "",
              mounted: "",
              displayConds: []
            },
            {
              id: "img_51c1ba78",
              type: "img",
              style: {
                position: "absolute",
                left: "43.5%",
                width: "14%",
                height: "auto",
                top: "84%",
                right: "",
                bottom: "",
                backgroundImage: "",
                backgroundColor: "",
                backgroundRepeat: "no-repeat",
                backgroundSize: "100% 100%",
                color: "",
                fontSize: "",
                fontWeight: ""
              },
              name: "图片",
              src: "https://file.neware.com.cn/ImageMaterialCenter/B.png",
              url: "https://neware-store.com/zh/activity/customForm?type=6&formId=1377",
              events: "",
              created: "",
              mounted: "",
              displayConds: []
            },
            {
              id: "img_6bf90a48",
              type: "img",
              style: {
                position: "absolute",
                left: "44%",
                width: "12%",
                height: "auto",
                top: "48%",
                right: "",
                bottom: "",
                backgroundImage: "",
                backgroundColor: "",
                backgroundRepeat: "no-repeat",
                backgroundSize: "100% 100%",
                color: "",
                fontSize: "",
                fontWeight: ""
              },
              name: "图片",
              src: "https://file.neware.com.cn/ImageMaterialCenter/A.png",
              url: "https://www.neware-store.com/zh/pointsMall/",
              events: "",
              created: "",
              mounted: "",
              displayConds: []
            }
          ],
          events: "",
          created: "",
          mounted: "",
          displayConds: []
        },
        {
          id: "container_b0552e95",
          type: "container",
          layout: "relative",
          style: {
            width: "100%",
            height: "auto",
            position: "relative",
            top: 0,
            left: 0,
            right: "",
            bottom: "",
            backgroundImage: "",
            backgroundColor: "rgba(255, 255, 255, 1)",
            backgroundRepeat: "no-repeat",
            backgroundSize: "100% 100%",
            color: "",
            fontSize: "",
            fontWeight: ""
          },
          name: "容器",
          items: [
            {
              id: "img_1f79aff1",
              type: "img",
              style: {
                position: "relative",
                left: 0,
                width: "100%",
                height: "auto",
                top: 0,
                right: "",
                bottom: "",
                backgroundImage: "",
                backgroundColor: "",
                backgroundRepeat: "no-repeat",
                backgroundSize: "100% 100%",
                color: "",
                fontSize: "",
                fontWeight: ""
              },
              name: "图片",
              src: "https://file.neware.com.cn/ImageMaterialCenter/20240829164235845.jpg",
              url: "",
              events: "",
              created: "",
              mounted: "",
              displayConds: []
            }
          ],
          events: "",
          created: "",
          mounted: "",
          displayConds: []
        }
      ],
      mounted: "",
      displayConds: []
    }
  ],
  dataSources: [],
  dataSourceDeps: {}
}];